module.exports = __webpack_public_path__ + "media/assets/images/flags/ec-686254bac0f471730d3f6becb7111cc6.svg";